// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Table, Tooltip, Button } from '@gamesb42/ui-kit';

import { getFileFA } from 'components/forms/CompanyForm/reportsData';
import baseRequest from 'queries/baseRequest';
import { createCompanyAgreement } from 'api/company';
import { useUserContext } from 'contexts/UserProvider';
import { isAdmin } from 'helpers/token';
import EditModal from './EditModal';

import styles from './styles.module.scss';

import pencilSvg from 'assets/img/newPencil.svg';
import downloadSvg from 'assets/img/download.svg';

function renderStatus(status) {
  switch (status) {
    case 'sent':
      return (
        <div
          style={{
            display: 'flex',
            width: '54px',
            height: '24px',
            borderRadius: '4px',
            background: '#9FA5B9',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
          }}
        >
          SENT
        </div>
      );
    case 'created':
      return (
        <div
          style={{
            display: 'flex',
            width: '80px',
            height: '24px',
            borderRadius: '4px',
            background: '#95B3FF',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
          }}
        >
          CREATED
        </div>
      );
    case 'signed':
      return (
        <div
          style={{
            display: 'flex',
            width: '146px',
            height: '24px',
            borderRadius: '4px',
            background: '#95B3FF',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
          }}
        >
          SIGNED BY CLIENT
        </div>
      );
    case 'delivered':
      return (
        <div
          style={{
            display: 'flex',
            width: '100px',
            height: '24px',
            borderRadius: '4px',
            background: '#95B3FF',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
          }}
        >
          DELIVERED
        </div>
      );
    case 'completed':
      return (
        <div
          style={{
            display: 'flex',
            width: '106px',
            height: '24px',
            borderRadius: '4px',
            background: '#32D141',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
          }}
        >
          COMPLETED
        </div>
      );
    default:
      return '-';
  }
}

const FA = ({
  companyId,
  setCompanyData,
  refreshCompany,
  faVersion,
}: {
  companyId: string;
  setCompanyData: any;
  refreshCompany: () => Promise<unknown>;
  faVersion: number;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});
  const [status, setStatus] = useState('-');
  const [btn1Loading, setBtn1Loading] = useState(false);
  const { user } = useUserContext();
  // Убираем локальную переменную isAdmin
  const [open, setOpen] = useState(false);

  const columns = [
    {
      title: 'Factoring Agreement No.',
      dataIndex: 'file_name',
      width: '248px',
      align: 'left' as 'left',
      render: (text: string) => <span style={{ color: '#7145EC', textDecoration: 'underline' }}>{text}</span>,
    },
    {
      title: 'Signing',
      dataIndex: 'status',
      width: '279px',
      align: 'left' as 'left',
      render: () => renderStatus(status),
    },
    {
      title: '',
      dataIndex: '',
      align: 'left' as 'left',
      render: (row) => {
        if (isAdmin()) {
          return (
            <div style={{ display: 'flex', height: '100%', gap: '32px', alignItems: 'center' }}>
              <Button
                style={{
                  visibility: status === 'created' ? 'visible' : 'hidden',
                  width: '132px',
                  padding: 0,
                  justifyContent: 'center',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                loading={btn1Loading}
                onClick={handleGeneratNew}
              >
                Generate new
              </Button>
              <Button
                style={{
                  visibility: status === 'created' ? 'visible' : 'hidden',
                  minWidth: '164px',
                  height: '24px',
                  padding: 0,
                  justifyContent: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '4px',
                  background: 'var(--grey-gray-8-btn-hover, #9197AD)',
                }}
                onClick={() => setOpen(true)}
                type="primary"
              >
                Change to Signed
              </Button>
              <Tooltip title="Edit">
                <img
                  style={{ cursor: 'pointer', width: 18 }}
                  onClick={(e) => {
                    // handleDownload();
                    setOpen(true);
                  }}
                  src={pencilSvg}
                />
              </Tooltip>
              <Tooltip title="Download">
                <img
                  style={{ cursor: 'pointer', width: 18 }}
                  onClick={(e) => {
                    handleDownload();
                  }}
                  src={downloadSvg}
                />
              </Tooltip>
            </div>
          );
        } else {
          return (
            <div
              style={{ display: 'flex', height: '100%', gap: '32px', alignItems: 'center', justifyContent: 'flex-end' }}
            >
              <Tooltip title="Download">
                <img
                  style={{ cursor: 'pointer', width: 18 }}
                  onClick={(e) => {
                    handleDownload();
                  }}
                  src={downloadSvg}
                />
              </Tooltip>
            </div>
          );
        }
      },
    },
  ];

  async function getFAData() {
    try {
      const result = await baseRequest({
        path: `${process.env.REACT_APP_BASE_URL}/agreement/company/${companyId}`,
        options: {
          method: 'GET',
        },
      });

      if (!result?.detail) {
        setData(result);
      }

      setStatus(result.status);
    } catch (error) {
      console.error('Ошибка при получении данных факторингового соглашения:', error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getFAData();
  }, [faVersion]);

  function handleGeneratNew() {
    setBtn1Loading(true);
    return createCompanyAgreement(companyId)
      .then((data) => setCompanyData(data))
      .then(() => {
        getFAData();
      })
      .catch(() => {})
      .finally(() => {
        setBtn1Loading(false);
      });
  }

  async function handleAgreementSigned() {
    await getFAData();
    setStatus('completed');
    await refreshCompany();
  }

  async function handleDownload() {
    getFileFA(`${process.env.REACT_APP_BASE_URL}/agreement/${data.agreement_id}/file`);
  }

  return (
    <div className={styles.wrapper}>
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={Object.keys(data).length > 0 ? [data] : []}
        // rc-table на любом scroll.y включает постоянный overflow-y: scroll
        scroll={undefined}
      />
      <EditModal open={open} setOpen={setOpen} agreementId={data?.agreement_id} onSuccess={handleAgreementSigned} />
    </div>
  );
};

export default FA;
